//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
let d=[[[0,"DataTypeOption",1,0],[0,"DefinitionMethodOption",1,0],[0,"DoubleSidedMaximumValue",1,0],[0,"DoubleSidedMinimumValue",1,0],[0,"Formula",1,0],[0,"Name",1,0],[0,"RelationalOperatorOption",1,0],[0,"RelationalOperatorOptionOnMaximumValue",1,0],[0,"RelationalOperatorOptionOnMinimumValue",1,0],[0,"RequirementTolerance",1,0],[0,"RequirementTypeOption",1,0],[0,"SeverityOption",1,0],[0,"SingleSidedValue",1,0]],[[["nValidValues"],"GetValidValues",{R_:{validValues:""}},0,0],[["validValues"],"SetValidValues",{},1,0],[["nRequirementDescription"],"GetRequirementDescription",{R_:{requirementDescription:""}},0,0],[["requirementDescription"],"SetRequirementDescription",{},1,0]],[]];
SPLM.Validate.RequirementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.RequirementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.RequirementBuilder.SeverityOptions = Object.freeze({
    "Error" : "Error", "Warning" : "Warning", "Information" : "Information"});

SPLM.Validate.RequirementBuilder.DataTypeOptions = Object.freeze({
    "Number" : "Number", "String" : "String", "Boolean" : "Boolean", "Integer" : "Integer", "Point" : "Point"});

SPLM.Validate.RequirementBuilder.DefinitionMethodOptions = Object.freeze({
    "SingleSidedComparison" : "SingleSidedComparison", "DoubleSidedComparison" : "DoubleSidedComparison", "SetOfValues" : "SetOfValues", "Formula" : "Formula"});

SPLM.Validate.RequirementBuilder.RelationalOperatorOptions = Object.freeze({
    "Equal" : "Equal", "NotEqual" : "NotEqual", "LessThan" : "LessThan", "LessThanOrEqual" : "LessThanOrEqual", "GreaterThan" : "GreaterThan", "GreaterThanOrEqual" : "GreaterThanOrEqual"});

SPLM.Validate.RequirementBuilder.RequirementTypeOptions = Object.freeze({
    "ValidationLimit" : "ValidationLimit", "DesignLimit" : "DesignLimit"});

export default SPLM;